<!-- ContractSelectorModal.vue - 项目选择弹窗组件 -->
<template>
    <a-modal
        title="选择项目"
        :visible="visible"
        @cancel="handleCancel"
        :footer="null"
        width="800px"
    >
        <a-input-search
            v-model="searchValue"
            style="margin-bottom: 16px"
            placeholder="请输入设计编号搜索"
            enter-button
            @search="onSearch"
        />

        <a-table
            bordered
            :data-source="list"
            :loading="loading"
            :pagination="{
                total,
                current,
                pageSize,
                showTotal: (total) => `共 ${total} 条记录`,
                showSizeChanger: true,
                pageSizeOptions: ['10', '20', '50', '100']
            }"
            :rowClassName="() => 'clickable'"
            :customRow="(record) => ({
                on: {
                    click: () => onTableRowClick(record)
                }
            })"
            rowKey="id"
            @change="handleTableChange"
        >
            <a-table-column title="设计编号" data-index="code" width="150px" />
            <a-table-column title="项目名称" data-index="name" />
            <a-table-column title="合同金额(万元)" data-index="contractAmount" align="right" width="150px">
                <template slot-scope="contractAmount">
                    <span style="color: #1890ff">{{ formatAmount(contractAmount) }}</span>
                </template>
            </a-table-column>
        </a-table>
    </a-modal>
</template>

<script>
import { fetchList } from "@/api/contract"

export default {
    name: "ContractSelectorModal",
    props: {
        visible: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false,
            searchValue: '',
            list: [],
            total: 0,
            current: 1,
            pageSize: 10
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.getList()
            }
        }
    },
    methods: {
        formatAmount(value) {
            if (value === undefined || value === null) return '0.00'
            return Number(value).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        async getList() {
            this.loading = true
            try {
                const params = {
                    pageNum: this.current,
                    pageSize: this.pageSize
                }
                if (this.searchValue) {
                    params.code = this.searchValue
                }
                const res = await fetchList(params)
                this.list = res?.list || []
                this.total = res?.totalSize || 0
            } catch (error) {
                console.error('查询项目列表失败:', error)
            } finally {
                this.loading = false
            }
        },

        onSearch(value) {
            this.searchValue = value
            this.current = 1
            this.getList()
        },

        handleTableChange(pagination) {
            this.current = pagination.current
            this.pageSize = pagination.pageSize
            this.getList()
        },

        onTableRowClick(record) {
            this.$emit('select', record)
            this.handleCancel()
        },

        handleCancel() {
            this.searchValue = ''
            this.current = 1
            this.$emit('cancel')
        }
    }
}
</script>

<style scoped>
.clickable {
    cursor: pointer;
}

.clickable:hover {
    background-color: #e6f7ff;
}
</style>